module.exports = __webpack_public_path__ + "img/health-item2.422fe37e.png";